<template>
    <v-app>
        <app-header @logout="logout"></app-header>
        <v-content>
            <router-view></router-view>
        </v-content>
        <app-footer></app-footer>
    </v-app>
</template>

<script>
    import AddProductService from "../../app-front/services/api/AddProductService";
    import AddToBasket from "../../app-front/mixins/AddToBasket";
    import AppHeader from '../../app-front/components/header'
    import AppFooter from '../../app-front/components/footer';
    import AppLang from '../../app-front/mixins/AppLang';
    import Auth from '../../app-front/mixins/Auth';
    import Favorites from '../../app-front/mixins/Favorites';
    import NoLoginBasket from "../../app-front/mixins/NoLoginBasket";
    import ProductsCompare from "../../app-front/mixins/ProductsCompare";
    import InfoService from '../../app-front/services/api/InfoService';
    import GeoService from '../../app-front/services/api/GeoService';

    export default {
        name: "App",
        mixins: [AppLang, Auth, Favorites, AddToBasket, NoLoginBasket, ProductsCompare],
        props: {
            source: String,
        },
        components: {
            AppHeader,
            AppFooter
        },
        computed: {
            appCurrency() {
                return this.$store.state.appCurrency;
            }
        },
        methods: {
            addJivoScript() {
                let link = document.createElement('script');
                link.src = '//code.jivosite.com/widget/QHhXqGTq7z';
                link.async = true;
                document.head.appendChild(link);
            },
            currencyHandle() {
                const currency = window.localStorage.getItem('appCurrency') || this.$store.state.currency[0].name;
                window.localStorage.setItem('appCurrency', currency);
                this.$store.commit('setAppCurrency', currency);
            },
            setMainInfo() {
                this.setRegions();
                this.setPaymentWays();

                InfoService.setLocale(this.$store.state.language.appLanguage);
                InfoService.getMainInfo().then(res => {
                    Object.entries(res.data).forEach(([name, value]) => {
                        this.$store.commit('setValueGeneral', {
                            name,
                            value,
                            key: 'baseInfo'
                        });
                    });
                })
                .catch(err => {
                    console.log(err)
                })
            },
            setPaymentWays() {
                AddProductService.setLocale(this.$store.state.language.appLanguage);
                AddProductService.getPaymentWays()
                    .then(res => {
                        const commitData = {
                            key: 'baseInfo',
                            name: 'paymentWays',
                            value: res.data
                        };

                        this.$store.commit('setValueGeneral', commitData);
                    })
                    .catch(err => console.log(err))
            },
            setRegions() {
                GeoService.setLocale(this.$store.state.language.appLanguage);
                GeoService.getRegionsLinks()
                    .then(res => {
                        const commitData = {
                            key: 'geo',
                            name: 'regions',
                            value: res.data
                        };

                        this.$store.commit('setValueGeneral', commitData);
                    })
                    .catch(err => console.log(err))
            },
            setCompares() {
                if(this.$store.getters.isLogged) {
                    this.setCompared();
                } else {
                    const ids = JSON.parse(localStorage.getItem('compared-products')) || []
                    this.$store.commit('setCompares', ids)
                }
            },
            getLocalBasket() {
                const products = JSON.parse(localStorage.getItem('NoLoginBasket') || '[]');
                this.$store.commit('setNoLoginBasket', products);
            }
        },
        beforeMount() {
            this.currencyHandle();
            this.checkAuth();
        },
        created(){
            // setTimeout(this.addJivoScript, 2000);
            this.setMainInfo();
            if (!this.isUserLoggedIn) {
                this.getLocalBasket();
            }
        },
        watch: {
            appCurrency() {
                window.axios.defaults.headers.common['X-Currency'] = this.appCurrency;
            },
            isUserLoggedIn() {
                if(this.isUserLoggedIn) {
                    if(this.noLoginBasketCount > 0) {
                        this.mergeNoLoginBasketWithBasket();
                    }

                    this.getBasketSimple();
                    this.getFavorites();

                    if(!this.$store.getters.isComparesUpdating)
                        this.setCompares();
                }
            },
            isAuthChecked() {
                this.setCompares();
            }
        }
    }
</script>

<style scoped>

</style>
